/**
 * Tabs
 */


(function($) {


    $('.js-tabs').neoTabs({
        wrapperClass: 'c-tabs__tab-content', // Classname of div to apply around the content
        activeClass: 'is-active', // Classname to apply to active tab
        tabHeadClass: 'c-tabs__tab-head', // Classname to apply to each generated tab
        tabBodyClass: 'js-tabs__tab-body', // Classname which describes the body of a tab content
        firstTabClass: 'first', // Classname to apply to the first tab of a tabs list
        lastTabClass: 'last', // Classname to apply to the last tab of a tabs list
        clearfixClass: '', // Class name for clearfix
        tabsListClass: 'c-tabs__nav', // Classname to apply to a tabs list
        tabHeadElement: '[data-tab-title]', // Selector which represents a tab
        tabsPosition: 'top', // Tabs-list position 'top' || 'bottom'
        cssClassAvailable: true, // Applying existing classes from tabHeadElement to tab
        fx: 'show', // Collapsing effect
        fxSpeed: 0, // Effect speed in milliseconds
        autoAnchor: true, // Making tabs linkable or not
        wrapInnerTabs: '', // Fragment for tab inner wrapping
        dropdownTabLabel: '&#x25BE;', // Dropdown tab label
        dropdownTabClass: 'dropdown', // Classname to apply to tab which represents a dropdown
        dropdownTabsListClass: 'tabs-list', // Classname to apply to tabs list within a dropdown
        dropdownTabsClearfixClass: '', // Clearfix for dropdown
        moreTabClass: 'c-tabs__more',
        moreTabLabel: '<span data-icon="ui_arrow_down"><span class="u-hide">Mehr</span></span>',
        moreTabItemClass: 'c-tabs__more-item',
    });


})(jQuery);
